import { defineComponent } from 'vue';
import CategoryOneComponent from '@/components/CategoryOne/CategoryOneComponent.vue';
export default defineComponent({
    name: 'CategoryOne',
    components: { CategoryOneComponent },
    data() {
        return {};
    }
});
